import { i18n_t } from '@utils/i18n';
const $t = i18n_t;

export function getItemCategoryIcon (type) {
    if (!type) return '';
    switch (type) {
        case 'all': return 'logo';
        case 'account': return 'users';
        case 'app': return 'monitor';
        case 'feature': return 'feature';
        case 'page': return 'page';
        case 'productArea': return 'grid';
        case 'segment': return 'pieChart';
        case 'trackEvent': return 'zap';
        case 'visitor': return 'user';
    }

    return '';
}

export function getItemCategoryLabel (type) {
    switch (type) {
        case 'all': return $t('askPendo.mentionTypeMenu.All');
        case 'account': return $t('askPendo.mentionTypeMenu.Account');
        case 'app': return $t('askPendo.mentionTypeMenu.Application');
        case 'feature': return $t('askPendo.mentionTypeMenu.Feature');
        case 'page': return $t('askPendo.mentionTypeMenu.Page');
        case 'productArea': return $t('askPendo.mentionTypeMenu.Product Area');
        case 'segment': return $t('askPendo.mentionTypeMenu.Segment');
        case 'trackEvent': return $t('askPendo.mentionTypeMenu.Track Event');
        case 'visitor': return $t('askPendo.mentionTypeMenu.Visitor');
    }

    return '';
}

export function getItemDetailsType (type) {
    if (!type) return '';
    switch (type) {
        case 'account':
        case 'visitor':
            return 'accountvisitor';
        case 'app':
            return 'app';
        case 'productArea':
            return 'productArea';
        case 'segment':
            return 'segment';
        case 'feature':
        case 'page':
        case 'trackEvent':
            return 'countable';
    }

    return '';
}

export function getItemText (item) {
    if (!item) return '';
    switch(item.type) {
        case 'account':
            return item.data.id;
        case 'app':
            return item.data.displayName || item.data.name;
        case 'feature':
        case 'page':
        case 'productArea':
        case 'segment':
        case 'trackEvent':
            return item.data.name;
        case 'visitor':
            return item.data.name || item.data.email || item.id;
    }

    return '';
}

export function itemFilter (query) {
    const lowercaseQuery = query.toLowerCase();

    return (item) => {
        const text = getItemText(item);

        return text.toLowerCase().includes(lowercaseQuery);
    };
}

export function itemSort (a, b) {
    const aText = getItemText(a);
    const bText = getItemText(b);

    return aText.localeCompare(bText);
}

export function normalizeItem (type) {
    return (item) => {
        return item ? {
            id: item.id,
            type,
            data: item,
        } : undefined;
    };
}